import { createGlobalState } from 'react-use';
import { getFeatureAnnouncementLocalStorageKey } from 'src/components/FeatureAnnouncementTrigger/utils';
import { FEATURE_ANNOUNCEMENTS } from 'src/constants/featureAnnouncements';

export default createGlobalState(() => {
	const announcements = Object.values(FEATURE_ANNOUNCEMENTS)
		.filter(
			(announcement) =>
				!announcement.endDateTsMillis ||
				announcement.endDateTsMillis > Date.now()
		)
		.sort((a, b) => b.addedDateTsMillis - a.addedDateTsMillis)
		// We only show the most recent 5 announcements.
		.slice(0, 5);

	const unseenCount = (() => {
		if (typeof window === 'undefined') {
			return 0;
		}

		return announcements.reduce((acc, announcement) => {
			const hasSeenAnnouncement =
				localStorage.getItem(
					getFeatureAnnouncementLocalStorageKey(announcement)
				) === 'true';

			return acc + (!hasSeenAnnouncement ? 1 : 0);
		}, 0);
	})();

	return { announcements, unseenCount };
});
